var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.reverseItems),function(item,i){return _c('v-list-item',{key:i,attrs:{"href":item.href}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.getText(i,item.text)))])],1)}),_c('v-list-item-action')],2)}
var staticRenderFns = []

export { render, staticRenderFns }